import { css } from 'lit'

export default css`
    :host {
        white-space: normal;
    }

    .container {
        position: relative;
        align-items: center;
        background: var(--TileContainer-background);
        border: 1px solid var(--grey6);
        display: grid;
        grid-template:
            'content summary action' 1fr
            / auto 1fr auto;
    }

    .container.preview {
        height: 100%;
        grid-template:
            'content content' auto
            'summary action ' 1fr
            / 1fr auto;
    }

    .content {
        grid-area: content;
        place-self: stretch;
        display: flex;
        place-content: center;
        place-items: center;
        position: relative;
    }

    .selected {
        background: #edf4fc;
        border: 1px solid var(--blue-500);

        &:hover {
            border: 1px solid var(--blue-600);
        }
    }

    .number {
        color: var(--grey-600);
        font-size: 12px;
        font-weight: 900;
        position: absolute;
        left: 8px;
        top: 8px;
    }

    .icon {
        align-items: center;
        display: flex;
        flex-shrink: 0;
        justify-content: center;
        overflow: hidden;
    }

    .main-icon {
        background: var(--backgroundGrey);
        background-repeat: no-repeat;
        background-position: center;
        min-height: 90px;
        width: var(--TileMainIcon-width, 116px);
        height: var(--TileMainIcon-height, 100%);
        background-size: var(--TileMainIcon-backgroundSize, none);
    }

    .checkbox-wrapper {
        position: absolute;
        top: 1.2rem;
        left: 1.2rem;

        width: 2.4rem;
        height: 2.4rem;

        display: flex;
        align-items: center;
        justify-content: center;

        input {
            width: 1.8rem;
            height: 1.8rem;
            margin: 0;
        }

        &.checkbox-show-never {
            display: none;
        }

        .container:not(:hover) &.checkbox-show-on-hover {
            display: none;
        }
    }

    .action-buttons {
        display: flex;
        position: absolute;
        right: 1.2rem;
        top: 1.2rem;
    }

    .delete-icon,
    .edit-icon {
        border: 1px solid var(--grey-400);
        border-radius: 4px;
        color: var(--grey3);
        cursor: pointer;
        display: none;
        align-items: center;
        font-size: 18px;
        flex-shrink: 0;
        justify-content: center;
        line-height: 0;
        overflow: hidden;
        background: var(--backgroundGrey);
        background-repeat: no-repeat;
        background-position: center;
        height: 32px;
        width: 32px;
        margin-left: 8px;
    }

    .delete-icon:active,
    .edit-icon:active {
        background: var(--grey-200);
    }

    .icon-cover {
        background-size: cover;
    }

    .summary {
        grid-area: summary;
        display: flex;
        height: 100%;
        flex-direction: column;
        flex-grow: 1;
        overflow: hidden;
        padding: var(--TileSummary-padding-top-bottom) var(--TileSummary-padding-right-left);
        white-space: nowrap;
    }

    .summary-size {
        min-width: 64px;
        min-height: var(--TileSummarySize-height);
        box-sizing: border-box;
    }

    .summary-icon {
        font-size: 16px;
    }

    .text-overflow {
        overflow: hidden;
    }

    .title {
        font-weight: var(--font-weight-medium);
        font-size: 14px;
    }

    .main-title {
        font-size: 14px;
        font-style: normal;
        font-weight: var(--font-weight-bold);
        color: var(--TileMainTitle-color);
        margin-bottom: var(--TileSummaryMainTitle-margin-bottom);
        display: flex;
        gap: 4px;
    }

    .subtitle {
        font-weight: var(--font-weight-medium);
        color: var(--grey3);
        font-size: 12px;
    }

    .extra-action {
        grid-area: action;
        align-items: center;
        display: flex;
        justify-content: center;
    }

    .extra-action-margin {
        margin: 0 20px;
    }

    .extra-action-btn {
        background: rgba(255, 255, 255, 0);
        border: none;
        padding: 0;
    }

    .container:hover,
    .extra-action-btn:hover {
        cursor: pointer;
    }

    .container:hover {
        cursor: var(--TileContainerHover-cursor);
    }

    .container:hover .delete-icon,
    .container:hover .edit-icon {
        display: flex;
    }

    .container:hover:not(.selected) {
        border: var(--TileContainerHover-border);
    }

    .container:hover .extra-action-btn img.not-hover {
        display: none;
    }

    .container:not(:hover) .extra-action-btn img.hover {
        display: none;
    }

    .extra-action-btn-size {
        height: 18px;
        width: 18px;
    }

    .extra-action-btn-size.large {
        height: 30px;
        width: 30px;
    }

    .extra-action-btn img {
        height: 100%;
        width: 100%;
    }

    .video-overlay {
        position: absolute;
    }

    .snippet {
        white-space: normal;
        margin-bottom: 8px;
        height: 100%;
        color: var(--grey-600);
    }
    .no-snippet {
        height: 100%;
    }

    @media screen and (max-width: 320px) {
        .extra-action-margin {
            margin: 0 5px;
        }
    }
`
